// extracted by mini-css-extract-plugin
export default {"item":"style_item__Uj80R","left":"style_left__qrk8u","updates":"style_updates__OJ23T","bonuses":"style_bonuses__JoHRw"};